import {
  HttpClient,
  HttpEvent,
  HttpEventType,
  HttpHeaders,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class DownloadService {
  private http: HttpClient = inject(HttpClient);

  downloadFile(blob: Blob, filename: string = 'video.mp4'): void {
    const fileUrl: string = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(fileUrl);
  }

  /**
   * Récupère une vidéo en tant que Blob pour streaming
   * @param jobId - ID du job
   * @returns Observable<Blob> - La vidéo sous forme de Blob
   */
  getVideoFinalStream(jobId: number): Observable<Blob> {
    const url: string = `${environment.apiUrl}/jobs/${jobId}/final`;

    const headers = new HttpHeaders({
      Accept: 'video/mp4',
    });

    return this.http
      .get(url, {
        responseType: 'blob',
        headers: headers,
      })
      .pipe(
        catchError((error) => {
          console.error('Erreur lors du chargement de la vidéo:', error);
          return throwError(() => error);
        })
      );
  }

  /**
   * Récupère une vidéo avec progress tracking
   * @param jobId - ID du job
   * @returns Observable<HttpEvent<Blob>> - Events de progression
   */
  getVideoWithProgress(jobId: number): Observable<HttpEvent<Blob>> {
    const url: string = `${environment.apiUrl}/jobs/${jobId}/final`;
    return this.http
      .get(url, {
        responseType: 'blob',
        reportProgress: true,
        observe: 'events',
        headers: new HttpHeaders({
          Accept: 'video/mp4',
          'Accept-Ranges': 'bytes',
        }),
      })
      .pipe(
        tap((event: HttpEvent<Blob>) => {
          if (event.type === HttpEventType.DownloadProgress) {
            // console.log('Event:', event);
            // console.log('Loaded:', event.loaded);
            // console.log('Total:', event.total);
          }
        }),
        catchError((error) => {
          console.error('Erreur lors du chargement avec progress:', error);
          return throwError(() => error);
        })
      );
  }

  downloadAsset(jobId: number, asset: string): Observable<HttpEvent<Blob>> {
    const url: string = `${environment.apiUrl}/script/assets/${jobId}/${asset}`;
    return this.http.get(url, {
      responseType: 'blob' as 'blob',
      observe: 'events',
    });
  }

  downloadAudioDemo(short: string): Observable<HttpEvent<Blob>> {
    const url: string = `${environment.apiUrl}/script/assets/demo/translated_${short}.wav`;
    return this.http.get(url, {
      responseType: 'blob' as 'blob',
      observe: 'events',
    });
  }

  downloadVideoDemo(): Observable<HttpEvent<Blob>> {
    const url: string = `${environment.apiUrl}/script/assets/demo/video.mp4`;
    return this.http.get(url, {
      responseType: 'blob' as 'blob',
      observe: 'events',
    });
  }
}
